module.exports = __webpack_public_path__ + "static/media/ParkZeus_WebApp_(Corporate)_T&C_June 26-FV-20-5-2022-PZ-Bosch_pop.2f9b0ce4.pdf";